<template>
  <div id="footer" class="acea-row row-middle">
    <router-link
      :to="item.url"
      class="item"
      :class="{ on: item.url === $route.path }"
      v-for="(item, index) in footerList"
      :key="index"
    >
      <!-- <div
        class="iconfont"
        :class="item.icon1 + ' ' + (item.url === $route.path ? item.icon2 : '')"
      ></div> -->
      <div class="iconfont">
        <img :src="item.url === $route.path ? item.icon2 : item.icon1" />
      </div>
      <div>{{ item.name }}</div>
    </router-link>
  </div>
</template>
<script>
import img1_1 from "@assets/images/nav/1_1.png";
import img1_2 from "@assets/images/nav/1_2.png";
import img2_1 from "@assets/images/nav/2_1.png";
import img2_2 from "@assets/images/nav/2_2.png";
import img3_1 from "@assets/images/nav/3_1.png";
import img3_2 from "@assets/images/nav/3_2.png";
import img4_1 from "@assets/images/nav/4_1.png";
import img4_2 from "@assets/images/nav/4_2.png";
export default {
  name: "Footer",
  props: {},
  data: function() {
    return {
      // footerList: [
      //   {
      //     name: "首页",
      //     icon1: "icon-shouye-xianxing",
      //     icon2: "icon-shouye",
      //     url: "/"
      //   },
      //   {
      //     name: "分类",
      //     icon1: "icon-yingyongchengxu-xianxing",
      //     icon2: "icon-yingyongchengxu",
      //     url: "/category"
      //   },
      //   {
      //     name: "购物车",
      //     icon1: "icon-caigou-xianxing",
      //     icon2: "icon-caigou",
      //     url: "/cart"
      //   },
      //   {
      //     name: "我的",
      //     icon1: "icon-yonghu-xianxing",
      //     icon2: "icon-yonghu",
      //     url: "/user"
      //   }
      // ]
      footerList: [
        {
          name: "首页",
          icon1: img1_1,
          icon2: img1_2,
          url: "/"
        },
        {
          name: "地市",
          icon1: img2_1,
          icon2: img2_2,
          url: "/citys"
        },
        {
          name: "购物车",
          icon1: img3_1,
          icon2: img3_2,
          url: "/cart"
        },
        {
          name: "我的",
          icon1: img4_1,
          icon2: img4_2,
          url: "/user"
        }
      ]
    };
  },
  methods: {}
};
</script>
